import { Section } from "../components/Section";

// Film photos (ui/public/about/, resized from the originals).
const PHOTOS = [
  { src: "/about/holly.jpg", alt: "Holly shooting a film camera, AJ behind her", pos: "30% 50%" },
  { src: "/about/florence.jpg", alt: "Florence the calico cat on a yellow couch", pos: "55% 40%" },
  { src: "/about/turbo.jpg", alt: "Turbo the corgi lying on a deck", pos: "50% 60%" },
];

export function About() {
  return (
    <Section id="about" label="about" title="Hi, I'm AJ.">
      <p className="etch-label etch mt-3 !text-[12px] !text-amber">
        Product @ Cloudflare · Turbo Photo Film Lab
      </p>

      <p className="mt-5 text-text-dim">
        <strong className="text-text">For work,</strong> I build things that impact people. 7+
        years at Cloudflare taking a brand new product area to market — SASE (secure access service
        edge) security. I was the global GTM and technical sales expert in the space for 4+ years,
        and sold and deployed to some of the world's largest companies. Now, I run Product for our
        SASE user experience and our entire Zero Trust firewall product set.
      </p>

      <p className="mt-4 text-text-dim">
        <strong className="text-text">For fun,</strong> I'm a big horror movie nerd —{" "}
        <a href="https://letterboxd.com/_aj/" target="_blank" rel="noopener">
          follow me on Letterboxd
        </a>
        . I aspire to do well enough in the tech sector that I can one day produce films. I spend a
        majority of my free time with my wife and high school sweetheart (Holly), our dog (Turbo),
        and our cat (Florence). We're all big homebodies. We've also started two successful
        businesses together — <a href="#lab">more on that further down</a>.
      </p>

      <div className="mt-8 grid grid-cols-[repeat(auto-fit,minmax(150px,1fr))] gap-4">
        {PHOTOS.map((p) => (
          <img
            key={p.src}
            src={p.src}
            alt={p.alt}
            loading="lazy"
            className="panel aspect-[4/5] w-full object-cover [image-rendering:auto]"
            style={{ objectPosition: p.pos }}
          />
        ))}
      </div>
    </Section>
  );
}
